import { render, staticRenderFns } from "./OfertaInfoPedidoMinimo.vue?vue&type=template&id=e35816da&"
import script from "./OfertaInfoPedidoMinimo.vue?vue&type=script&lang=js&"
export * from "./OfertaInfoPedidoMinimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports